import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { StudySubForm, Schema as StudySchema } from '../subforms/Study';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const HeukingJurMASchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema(settings))
        .concat(StudySchema(settings))
        .concat(NameAndContactSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const HeukingJurMA = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Alle mit * gekennzeichneten Felder sind Pflichtfelder und müssen ausgefüllt werden.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} settings={settings} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={StudySubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}